import { request } from '@/api/http';
import type { Category } from '@/api/types';

export const categoriesService = {
  list: () => request<Category[]>('/categories'),
};
